// noinspection DuplicatedCode

import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {alertService} from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {getKota, insertKota, kotaSelector, updateKota} from "./kotaSlice";

import {Colors} from "../../../assets/Colors";
import {maxPageGlobal} from "../../../assets/config";

function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

const KotaPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(maxPageGlobal);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);

    const [insertFetch, setInsertFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const kota = useSelector(kotaSelector);

    useEffect(() => {
        dispatch(
            getKota({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {

        if ((search !== '') && kota.isGetSuccess && !kota.isGetFetching) {
            let calc = kota?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = kota.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if ((search === '') && kota.isGetSuccess && !kota.isGetFetching) {
            let calc = kota?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = kota.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (!kota?.isGetFetching && kota.isGetSuccess && (maxPage === 0) && (firstLoading === false)) {
            let calc = kota?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = kota.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(getKota({
                start: start,
                count: count,
                search: search,
            }));
        }

        if (
            (insertFetch)
        ) {
            setInsertFetch(false);
            if (kota.isGetSuccess) {
                alertService.success(kota.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(getKota({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

        if (
            (updateFetch)
        ) {
            setUpdateFetch(false);
            if (kota.isUpdateSuccess) {
                alertService.success(kota.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(updateKota({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

    });

    // function handleGetKota(params) {
    //   return dispatch(getKota(params));
    // }

    function handleInsertKota(param) {
        setInsertFetch(true);
        const params = {
            namaKota: param.inputOneValue,
            provinsiID: param.dropdownProvinsiValue,
        };
        dispatch(insertKota(params));
    }

    function handleUpdateKota(param) {
        setUpdateFetch(true);

        const params = {
            provinsiID: param.dropdownProvinsiValue,
            namaKota: param.inputOneValue,
            kotaID: currentData.KotaID,
            status: param.status,
        };
        dispatch(updateKota(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getKota(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getKota(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = kota.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? kota.count : newCount,
            search: search,
        };
        dispatch(getKota(params));

        setPage(1);
        setCount(newCount === "-1" ? kota.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="Kota"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Kota"
                                tableData={kota.data}
                                colOneTitle="ID"
                                colOneData="KotaID"
                                colTwoTitle="Nama Pronvinsi"
                                colTwoData="NamaProvinsi"
                                colThreeTitle="Nama Kota"
                                colThreeData="NamaKota"
                                status="Status"
                                fetching={kota.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Kota"
                        dropdownProvinsi={true}
                        inputOneTitle="Nama Kota"
                        inputOnePlaceholder=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertKota}
                        // formData = {
                        //   [
                        //     {
                        //       fieldType: "inputfield",
                        //       title: "Input Field Title",
                        //       placeholder: "Select your item",
                        //       value: {},
                        //       // function: handleFunction,
                        //     },
                        //     {
                        //       fieldType: "dropdownfield",
                        //       search: false,
                        //       handleSearch: {handleGetMinKota},
                        //       dropdownData: minKota,
                        //       title: "Dropdown Field Title",
                        //       placeholder: "Select your item",
                        //       value: {},
                        //       // function: handleFunction,
                        //     },
                        //   ]
                        // }
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.KotaID}
                        modal={handleModal}
                        modalTitle="Ubah Kota"
                        dropdownProvinsi={true}
                        dropdownProvinsiValue={currentData.ProvinsiID}
                        dropdownKota={true}
                        dropdownKotaValue={currentData.KotaID}
                        inputOneTitle="Nama Kota"
                        inputOneValue={currentData.NamaKota}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateKota}
                    />
                )}
            </div>
        );
    }

    // async handleGetMinKota() {
    //   await this.props.dispatch(getMinKotaAction());
    // }

    // handleModal = (status) => {
    //   this.setState({
    //     showModalAdd: status.showModalAdd,
    //     showModalEdit: status.showModalEdit
    //   });
    // }

    // async handleInsertKota(param) {
    //   const params = {
    //     namaKota: param.inputOneValue,
    //   }

    //   await this.props.dispatch(insertKotaAction(params));
    // }

    // async handleUpdateKota(param) {
    //   const params = {
    //     namaKota: param.inputOneValue,
    //     idKota: this.state.currentData.KotaID,
    //     status: param.status,
    //   }

    //   await this.props.dispatch(updateKotaAction(params));
    // }

    // if (!this.state.firstLoading) {
    //   return <Loading />;
    // } else {

    // }
};

export default KotaPage;
